module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_black.83647466.png";